import { BaseAction } from './common';

export enum IngestStatusTypes {
  UPLOAD_INITIATED = 'Upload Initiated',
  UPLOAD_COMPLETED = 'Upload Completed',
  PROCESSING = 'Processing',
  SUCCESS = 'Success',
  ERROR = 'Error',
}

export enum ProjectStepStatus {
  INITIAL = 'Initialized',
  VALID = 'Valid',
  PENDING = 'Pending',
  WARNING = 'Warning',
  ERROR = 'Error',
}

export enum ProjectOutputStatus {
  INITIAL = 'initial',
  PENDING = 'pending',
  WARNING = 'warning',
  ERROR = 'error',
  COMPLETED = 'completed',
}

export enum ProjectStepTypes  {
  FORM = 'form',
  VALUES_FORM = 'values-form',
  DATA_GRID = 'data-grid',
  COMPLETE = 'complete',
}

export enum ProjectStepActionTypes {
  SUBMIT = 'submit',
  CANCEL = 'cancel',
  GENERATE = 'generate',
  QUERY = 'query',
}

export interface ProjectStep {
  slug: string;
  type: ProjectStepTypes;
  displayName: string;
  data?: any;
  errors?: any[];
  status?: ProjectStepStatus;
}

export interface Workbook {
  name: string;
  size: number;
}

export interface ProjectValueItem {
  data: any;
  name: string;
  schema: any;
}

export interface ProjectDataGridItem {
  id: number;
  name: string;
  slug: string;
  status: ProjectStepStatus;
  documents: { id: number; output_name: string }[];
}

export interface Project {
  ID: number;
  Name: string;
  Slug: string;
  UpdatedAt: string;
  Values?: ProjectValueItem[];
  DataGrids?: ProjectDataGridItem[];
  ProjectTemplate: ProjectTemplate;
}

export type ProjectStepAction = BaseAction<ProjectStepActionTypes, any>
